module.exports = __webpack_public_path__ + "media/images/menu/aries-1e307e1476c101aec7e463932ec2a21a.jpg";